export default {
  "Dietician Choice": require("../assets/icons/dietician.gif"),
  "Luxury Grade": require("../assets/icons/luxury.gif"),
  "Popular Choice": require("../assets/icons/popular.gif"),
};
